import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=6d1f67b5&scoped=true&"
import script from "./AddProject.vue?vue&type=script&lang=js&"
export * from "./AddProject.vue?vue&type=script&lang=js&"
import style0 from "./AddProject.vue?vue&type=style&index=0&id=6d1f67b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f67b5",
  null
  
)

component.options.__file = "www/vues/admin/controls/AddProject.vue"
export default component.exports